module.exports = __webpack_public_path__ + "static/Ilustracja3-54405818c8ce9eb4a37d71fb3b3c73a2.svg";